import { CoreFollowedIdMapName } from './name';
import { createAddSyncSlice } from '@sonar-software/xuder';
import { defaultFollowedIdMapState } from './state';

export const addCoreFollowedIdMapSlice = createAddSyncSlice({
	name: CoreFollowedIdMapName,
	state: defaultFollowedIdMapState,
	transform: (action: Array<number>, state: Record<number, boolean> = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			updatedState[ entry ] = true;
		}

		return updatedState;
	}
});
